import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import SupportContactModalContent from '../components/pages/waiting-area/support-contact/content';

function SupportContactModal(props) {
  const showSupportContactModal = useSelector((state) => state.modalReducer.showSupportContactModal);
  const supportContactForm = useSelector((state) => state.waitingAreaReducer.supportContactForm);
  const dispatch = useDispatch();

  return (
    <div>
      <SupportContactModalContent
        updateOrView={props.updateOrView}
        showSupportContactModal={showSupportContactModal}
        supportContactForm={supportContactForm}
        waitingArea={props.waitingArea}
        dispatch={dispatch}
      />
    </div>
  );
}
export default SupportContactModal;
